import { Action, createActionGroup, createFeature, createFeatureSelector, createReducer, on } from '@ngrx/store'
import { AllSameKeysAsPropertyValueEnforcer, AllSameKeysEnforcer } from '../helpers/helpers';
import { performerTableColumnTitles, sessionsTableColumnTitles, performerTableSelectedColumns, sessionsTableSelectedColumns, sponsorColumnTitles, sponsorSessionSelectedColumns, sponsorSelectedColumns, shareTableColumnTitles, timeLogColumnTitles, publishTableColumnTitles, timeLogSelectedColumns, publishTableSelectedColumns, performerBriefTableSelectedColumns, exhibitorColumnTitles, exhibitorSelectedColumns, allTaskColumnTitles, taskColumnTitles, DefaultColumnSelectData, exhibitorStandColumnTitles, exhibitorStandSelectedColumns, assetSelectedColumns, resourceSelectedColumns, quoteColumnTitles, quoteSelectedColumns, programTableSelectedColumns, programTableColumnTitles, taskSelectedColumns, attendeeSelectedColumns, attendeeColumnTitles } from '../helpers/table-helpers';
import { sponsorSessionColumnTitles, performerBriefTableColumnTitles, shareTableSelectedColumns, allTaskSelectedColumns, assetColumnTitles, resourceColumnTitles } from '../helpers/table-helpers';
import { getDefaultUserSettings, UserSettings } from '../../../globals/store/user.data';
import { Dictionary } from '@ngrx/entity';
import { ColumnOrderType } from '../../../globals/store/settings.data';
import { exhibitorColumns, performerTableColumns, resourceColumns, sessionColumns } from '../helpers/table-column-types';
import { userActions } from './user.era';
import { getSet } from 'globals/helpers/helpers';

export const UPDATE_USER_SETTINGS   = '[Settings] update user settings'
export const UPDATE_USER_SETTING    = '[Settings] update user setting'
export const UPDATE_NOTIF_SETTINGS  = '[Settings] update notification settings'
export const UPDATE_NOTIF_SETTING   = '[Settings] update notification setting'
export const UPDATE_SETTINGS_ACCOUNT = '[Settings] update account settings'

export interface EngageObject {
  is_engaged: boolean
  page:string
  extra_request_data:any
}

export interface WorkforceColumns { user, email, phone, role, title, company, aboutMe, groups, permissions }
export const workforceColumns: AllSameKeysAsPropertyValueEnforcer<WorkforceColumns> = [
  { value: 'user', selected: true },
  { value: 'email', selected: true },
  { value: 'phone', selected: true },
  { value: 'role', selected: true },
  { value: 'title', selected: true },
  { value: 'company', selected: true },
  { value: 'aboutMe', selected: true },
  { value: 'groups', selected: false },
  { value: 'permissions', selected: true },
]

export const columnOrderTypes: { [k in ColumnOrderType]: k } = { workforce: 'workforce', tasksTable : 'tasksTable', performersTable: 'performersTable', performerSessionsTable: 'performerSessionsTable', sponsors: 'sponsors', sponsor_sessions: 'sponsor_sessions', publishTable: 'publishTable', briefTable: 'briefTable', shareTable: 'shareTable', timeLog: 'timeLog', exhibitors: 'exhibitors', exhibitor_stands: 'exhibitor_stands', allTasks: 'allTasks', myTasks: 'myTasks', asset_table: 'asset_table', resources: 'resources', quotes: 'quotes', performerContactsView: 'performerContactsView', performerLogisticsView: 'performerLogisticsView', performerPublishView: 'performerPublishView', resourceContactsView: 'resourceContactsView', resourceLogisticsView: 'resourceLogisticsView', exhibitorContactsView: 'exhibitorContactsView', exhibitorLogisticsView: 'exhibitorLogisticsView', exhibitorPublishView: 'exhibitorPublishView', sessionLogisticsView: 'sessionLogisticsView', sessionPublishView: 'sessionPublishView', programs: 'programs', attendees: 'attendees' }

const workforceColumnTitles: AllSameKeysEnforcer<WorkforceColumns> = { user: 'Name', phone: 'Mobile number', role: 'Role', groups: 'Groups', title: 'Job Title', company: 'Company', aboutMe: 'About', email: 'Email', permissions: 'Permissions' }

export const columnTitles: { [t in ColumnOrderType]: Dictionary<string> }  = {
  attendees: attendeeColumnTitles,
  workforce: workforceColumnTitles,
  performersTable: performerTableColumnTitles,
  performerContactsView: performerTableColumnTitles,
  performerLogisticsView: performerTableColumnTitles,
  performerPublishView: performerTableColumnTitles,
  performerSessionsTable: sessionsTableColumnTitles,
  sponsors: sponsorColumnTitles,
  sponsor_sessions: sponsorSessionColumnTitles,
  timeLog: timeLogColumnTitles,
  shareTable: shareTableColumnTitles,
  briefTable: performerBriefTableColumnTitles,
  publishTable: publishTableColumnTitles,
  exhibitors: exhibitorColumnTitles,
  exhibitor_stands: exhibitorStandColumnTitles,
  tasksTable: taskColumnTitles,
  allTasks: allTaskColumnTitles,
  myTasks: taskColumnTitles,
  asset_table: assetColumnTitles,
  resources: resourceColumnTitles,
  resourceContactsView: resourceColumnTitles,
  resourceLogisticsView: resourceColumnTitles,
  exhibitorContactsView: exhibitorColumnTitles,
  exhibitorLogisticsView: exhibitorColumnTitles,
  exhibitorPublishView: exhibitorColumnTitles,
  quotes: quoteColumnTitles,
  programs: programTableColumnTitles,
  sessionPublishView: sessionsTableColumnTitles,
  sessionLogisticsView: sessionsTableColumnTitles
}

const performerContactDetailsColumns: Set<string> = new Set([
  performerTableColumns.name, performerTableColumns.performerType, performerTableColumns.contactName, performerTableColumns.email,
  performerTableColumns.phone, performerTableColumns.address, performerTableColumns.contact, performerTableColumns.labels
])
const performerPublishColumns: Set<string> = new Set([
  performerTableColumns.name, performerTableColumns.performerType, performerTableColumns.hideInPublish, performerTableColumns.confirmed,
  performerTableColumns.photo, performerTableColumns.line1, performerTableColumns.line2, performerTableColumns.logo, performerTableColumns.bio, performerTableColumns.social, performerTableColumns.labels, performerTableColumns.publicEditProfileStatus
])
const performerLogisticsColumns: Set<string> = new Set([
  performerTableColumns.name, performerTableColumns.performerType, performerTableColumns.stars, performerTableColumns.status, performerTableColumns.sessions, 
  performerTableColumns.sessionsAccepted, performerTableColumns.briefed, performerTableColumns.assets,
  performerTableColumns.sessionAssets, performerTableColumns.briefActions, performerTableColumns.briefUrl, performerTableColumns.terms, performerTableColumns.contact, 
  performerTableColumns.labels
])

const resourceContactDetailsColumns: Set<string> = new Set([
  resourceColumns.name, resourceColumns.resourceType, resourceColumns.contactName, resourceColumns.contactEmail, resourceColumns.contactNumber,
  resourceColumns.workforceContact, resourceColumns.description, resourceColumns.logo, resourceColumns.social
])
const resourceLogisticsColumns: Set<string> = new Set([
  resourceColumns.name, resourceColumns.resourceType, resourceColumns.stars, resourceColumns.editingUrlStatus, resourceColumns.detailsConfirmed,
  resourceColumns.files, resourceColumns.assets, resourceColumns.terms
])

const exhibitorContactDetailsColumns: Set<string> = new Set([
  exhibitorColumns.name, exhibitorColumns.exhibitorType, exhibitorColumns.confirmed, exhibitorColumns.contactName, exhibitorColumns.contactEmail, 
  exhibitorColumns.address, exhibitorColumns.contactNumber, exhibitorColumns.workforceContact
])
const exhibitorPublishColumns: Set<string> = new Set([
  exhibitorColumns.name, exhibitorColumns.exhibitorType, exhibitorColumns.logo, exhibitorColumns.editingUrlStatus, exhibitorColumns.detailsConfirmed, 
  exhibitorColumns.hideInPublish, exhibitorColumns.description, exhibitorColumns.callToActionText, exhibitorColumns.callToActionUrl, 
  exhibitorColumns.social, exhibitorColumns.labels
])
const exhibitorLogisticsColumns: Set<string> = new Set([
  exhibitorColumns.name, exhibitorColumns.exhibitorType, exhibitorColumns.confirmed, exhibitorColumns.stands, exhibitorColumns.program,
  exhibitorColumns.assets, exhibitorColumns.standAssets, exhibitorColumns.briefUrl, exhibitorColumns.briefActions, exhibitorColumns.terms, 
  exhibitorColumns.workforceContact, exhibitorColumns.labels
])

const sessionPublishColumns: Set<string> = new Set([
  sessionColumns.programName, sessionColumns.name, sessionColumns.duration, sessionColumns.description, sessionColumns.sessionLabels, sessionColumns.confirmed,
  sessionColumns.performers, sessionColumns.dateTime, sessionColumns.sponsors, sessionColumns.sessionUrl, sessionColumns.publicLinks,
  sessionColumns.showInPublish
])
const sessionLogisticsColumns: Set<string> = new Set([
  sessionColumns.programName, sessionColumns.name, sessionColumns.duration, sessionColumns.attendees, sessionColumns.flagged, sessionColumns.performerStatus, sessionColumns.stagingRequests,
  sessionColumns.assets, sessionColumns.performerAssets, sessionColumns.sponsorAssets, sessionColumns.briefed, sessionColumns.briefNotes, 
  sessionColumns.stagingNotes
])


export const defaultColumns: { [t in ColumnOrderType]: DefaultColumnSelectData[] } = {
  workforce: workforceColumns,  
  programs: programTableSelectedColumns,
  sessionLogisticsView: sessionsTableSelectedColumns.map(c => ({ ...c, selected: sessionLogisticsColumns.has(c.value) })),
  sessionPublishView: sessionsTableSelectedColumns.map(c => ({ ...c, selected: sessionPublishColumns.has(c.value) })),
  performersTable: performerTableSelectedColumns,
  performerContactsView: performerTableSelectedColumns.map(c => ({ ...c, selected: performerContactDetailsColumns.has(c.value) })),
  performerLogisticsView: performerTableSelectedColumns.map(c => ({ ...c, selected: performerLogisticsColumns.has(c.value) })),
  performerPublishView: performerTableSelectedColumns.map(c => ({ ...c, selected: performerPublishColumns.has(c.value) })),
  resourceContactsView: resourceSelectedColumns.map(c => ({ ...c, selected: resourceContactDetailsColumns.has(c.value) })),
  resourceLogisticsView: resourceSelectedColumns.map(c => ({ ...c, selected: resourceLogisticsColumns.has(c.value) })),
  exhibitorContactsView: exhibitorSelectedColumns.map(c => ({ ...c, selected: exhibitorContactDetailsColumns.has(c.value) })),
  exhibitorLogisticsView: exhibitorSelectedColumns.map(c => ({ ...c, selected: exhibitorLogisticsColumns.has(c.value) })),
  exhibitorPublishView: exhibitorSelectedColumns.map(c => ({ ...c, selected: exhibitorPublishColumns.has(c.value) })),
  performerSessionsTable:sessionsTableSelectedColumns,
  sponsors: sponsorSelectedColumns,
  attendees: attendeeSelectedColumns,
  sponsor_sessions: sponsorSessionSelectedColumns,
  timeLog: timeLogSelectedColumns,
  shareTable: shareTableSelectedColumns,
  briefTable: performerBriefTableSelectedColumns,
  publishTable: publishTableSelectedColumns,
  exhibitors: exhibitorSelectedColumns,
  exhibitor_stands: exhibitorStandSelectedColumns,
  allTasks: allTaskSelectedColumns,
  tasksTable: taskSelectedColumns,
  myTasks: taskSelectedColumns,
  asset_table: assetSelectedColumns,
  resources: resourceSelectedColumns,
  quotes: quoteSelectedColumns
}

export interface AccountsSettings {
  [accountId:string]:AccountSettings
}
export interface AccountSettings {
  accountId:string
}
export interface SettingsState {
   user:UserSettings
   accounts:AccountsSettings
}

const initialStateCreator = (): SettingsState => ({ user: getDefaultUserSettings(), accounts: {} });

// Actions
export const settingsActions = createActionGroup({
  source: 'Settings',
  events: {
    'Update User Settings': (payload:Partial<UserSettings>) => ({ payload }),
    'Update Notification Settings': (payload:any) => ({ payload }),
    'Update User Setting': (key:string, value:any) => ({ key, value }),
    'Update Notification Setting': (key:string, value:string) => ({ key, value }),
    'Update Settings Account': (accountId:string, key:string, value:string) => ({ accountId, key, value }),
  }
})

const updateColumns = (defaultColumns: DefaultColumnSelectData[], columns: DefaultColumnSelectData[]) => {
  const columnKeys = getSet(columns, 'value')
  const newPositionColumns = defaultColumns.filter(c => !columnKeys.has(c.value) && typeof c.newInsertIndex !== 'undefined')
  newPositionColumns.forEach(({ value, newInsertIndex, selected }) => {
    if(columns.length > newInsertIndex) columns.splice(newInsertIndex, 0, { value, selected })
    else columns.push({ value, selected })
    columnKeys.add(value)
  })

  const defaultColumnKeys = getSet(defaultColumns, 'value')
  const newBackColumns = defaultColumns.filter(defaultColumn => !columnKeys.has(defaultColumn.value))

  return [...columns, ...newBackColumns ].filter(c => defaultColumnKeys.has(c.value))
}

const correctUserSettings = (settings: Partial<UserSettings>) => {
  console.log({settings})
  if (!settings.hiddenTips) settings.hiddenTips = []
  Object.keys(defaultColumns).forEach(columnType => { 
    const key = `${columnType}_columns`
    if (settings[key]) {
      settings[key] = updateColumns(defaultColumns[columnType], settings[key])
    }
  })

  return settings
}

// Reducers
export const settingsReducer = createReducer(
  initialStateCreator(),
  on(settingsActions.updateUserSettings, (state, { payload }) => {
    const newSettings = {
      ...state.user,
      ...correctUserSettings({...payload}),
      notifs: {
        ...state.user.notifs,
        ...payload.notifs
      }
    }
    return {
      ...state,
      user: newSettings
    }
  }),
  on(settingsActions.updateNotificationSettings, (state, { payload }) => ({
      ...state,
      user:{
        ...state.user,
        notifs: payload
      }
  })),
  // on(userActions.updateUser, (state, { changes: user }) => ({
  //   ...state,
  //   user: user.settings ? correctUserSettings(user.settings) : getDefaultUserSettings()
  // })),
  on(settingsActions.updateUserSetting, (state, { key, value }) => ({
      ...state,
      user:{
        ...state.user,
        [key]: value
      }
  })),
  on(settingsActions.updateNotificationSetting, (state, { key, value }) => ({
      ...state,
      user:{
        ...state.user,
        notifs:{
          ...state.user.notifs,
          [key]: value
        }
      }
  })),
  on(settingsActions.updateSettingsAccount, (state, { accountId, key, value }) => {
      const accounts = {...state.accounts}
      if(!accounts[accountId]) accounts[accountId] = { accountId }
      accounts[accountId][key] = value
      return {
          ...state,
          accounts
      }
  }),
  on(userActions.logout, (state) => ({ ...initialStateCreator() })),
);

export const settingsFeature = createFeature({
  name: 'settings',
  reducer: settingsReducer,
  extraSelectors: ({ selectSettingsState }) => ({
    selectUserHomepage: (state) =>state.user.user.settings.homepage || 'card',
    selectAccountSettings: (accountId:string) => (state) => state.accounts[accountId] || { accountId } as AccountSettings
  })
});


export const settingsStateSelector = createFeatureSelector<SettingsState>('settings');

